<template>
  <editor
      v-model="text"
      :init="options"
      :api-key="apiKey"
      disabled
  ></editor>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';
export default {
  name: "TinymceEditor",
  components:{
    Editor
  },
  props:{
    contents:{
      type:String,
    },
  },
  data() {
    return {
      options: {
        menubar: false,
        statusbar: false,
        toolbar: false,
        body_class: 'viewer-tinymce',
        skin: 'snow',
        plugins: ['codesample', 'autoresize'],
        content_style: 'p { margin : 0 } img { max-width : 934px }',
      },
      apiKey: process.env.VUE_APP_TINYMCE_KEY,
    }
  },
  computed: {
    text: {
      get() {
        return this.contents;
      },
      set(newVal) {
        this.$emit('update', newVal);
        return newVal;
      },
    },
  },
}
</script>
<style>
.tox-tinymce {
  border: none !important;
}
</style>
